webpackJsonp([49],{

/***/ 1072:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_cost_standard_vue__ = __webpack_require__(1184);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f68f3f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_cost_standard_vue__ = __webpack_require__(1299);
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_cost_standard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f68f3f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_cost_standard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);



// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseIncome: function expenseIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/income', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dailyReport: function dailyReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/send/shift', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByCus: function holdingByCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByPaybill: function holdingByPaybill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByRemain: function holdingByRemain(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleType: function saleType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDocType: function saleDocType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleByItem: function saleByItem(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportSaleCustomer: function reportSaleCustomer(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportHoldbillInvoice: function reportHoldbillInvoice(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardReport: function StandardReport(URL, header, body, success, error) {
    console.log(body);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardCostReport: function StandardCostReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_service__ = __webpack_require__(511);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import apiItem from '../services/service_item'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      report_data: [],
      startDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()),
      endDate: __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      strucB: [],
      group_item: [],
      all_data: [],
      group: 0,
      price_cal_vat: 0
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var branch, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, values, obj, _all_data, urlWithNoCache, data, sortData, _obj, _data, _sortData;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                branch = 0;

                if (_this.branch !== 0) {
                  branch = _this.branch.id;
                }

                _this.all_data = [];
                _this.$store.state.isLoading = true;

                if (!(branch === 0)) {
                  _context.next = 48;
                  break;
                }

                _this.$store.state.isLoading = true;

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this.$store.state.branch_list);

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 30;
                  break;
                }

                values = _step.value;
                obj = {
                  start_date: _this.dateFormatDMY2(_this.startDate),
                  end_date: _this.dateFormatDMY2(_this.endDate),
                  company_id: 1,
                  branch_id: values.id,
                  item_code: '',
                  item_group: _this.group === 0 ? '' : _this.group.code,
                  group_start: _this.group === 0 ? '' : _this.group.code,
                  group_end: _this.group === 0 ? '' : _this.group.code
                };
                _context.prev = 14;

                // เพิ่ม timestamp กัน cache
                urlWithNoCache = sessionStorage.Url;
                _context.next = 18;
                return _this.standardReportPromise(urlWithNoCache, _this.header, obj);

              case 18:
                data = _context.sent;


                (_all_data = _this.all_data).push.apply(_all_data, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(data.branch_sub));

                // รอ 5 วินาที ก่อนดึงข้อมูลสาขาถัดไป
                _context.next = 22;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, 3000);
                });

              case 22:
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](14);

                _this.$notification['warning']({
                  message: 'ดึงข้อมูลรายงานไม่ได้',
                  description: _context.t0.message || 'เกิดข้อผิดพลาด'
                });

              case 27:
                _iteratorNormalCompletion = true;
                _context.next = 11;
                break;

              case 30:
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t1 = _context['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 36:
                _context.prev = 36;
                _context.prev = 37;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 39:
                _context.prev = 39;

                if (!_didIteratorError) {
                  _context.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context.finish(39);

              case 43:
                return _context.finish(36);

              case 44:

                _this.$store.state.isLoading = false;

                if (_this.all_data.length === 0) {
                  _this.$notification['warning']({
                    message: 'ไม่มีข้อมูล',
                    description: 'ไม่พบข้อมูลในช่วงวันที่ที่เลือก'
                  });
                } else {
                  sortData = _this.all_data.sort(function (a, b) {
                    return a.branch_name.localeCompare(b.branch_name);
                  });

                  _this.report_data = sortData;
                  _this.form_data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(sortData);

                  sortData.forEach(function (element) {
                    if (element.data) {
                      var groupData = element.data.sort(function (a, b) {
                        return a.group_code - b.group_code;
                      });
                      groupData.forEach(function (element1) {
                        if (element1.profit.sub === null) {
                          element1.profit.sub = [];
                        }
                        element1.profit.sub.sort(function (a, b) {
                          return a.item_code - b.item_code;
                        });
                      });
                    }
                  });
                }
                _context.next = 64;
                break;

              case 48:
                _obj = {
                  start_date: _this.dateFormatDMY2(_this.startDate),
                  end_date: _this.dateFormatDMY2(_this.endDate),
                  company_id: 1,
                  branch_id: branch,
                  item_code: '',
                  item_group: _this.group === 0 ? '' : _this.group.code,
                  group_start: _this.group === 0 ? '' : _this.group.code,
                  group_end: _this.group === 0 ? '' : _this.group.code
                };
                _context.prev = 49;
                _context.next = 52;
                return _this.standardReportPromise(sessionStorage.Url, _this.header, _obj);

              case 52:
                _data = _context.sent;

                _this.$store.state.isLoading = false;

                _sortData = _data.branch_sub.sort(function (a, b) {
                  return a.branch_name.localeCompare(b.branch_name);
                });

                _this.report_data = _sortData;
                _this.form_data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_sortData);

                _sortData.forEach(function (element) {
                  if (element.data) {
                    var groupData = element.data.sort(function (a, b) {
                      return a.group_code - b.group_code;
                    });
                    groupData.forEach(function (element1) {
                      if (element1.profit.sub === null) {
                        element1.profit.sub = [];
                      }
                      element1.profit.sub.sort(function (a, b) {
                        return a.item_code - b.item_code;
                      });
                    });
                  }
                });

                _context.next = 64;
                break;

              case 60:
                _context.prev = 60;
                _context.t2 = _context['catch'](49);

                _this.$store.state.isLoading = false;
                _this.$notification['warning']({
                  message: 'ดึงข้อมูลรายงานไม่ได้',
                  description: _context.t2.message || 'เกิดข้อผิดพลาด'
                });

              case 64:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 32, 36, 44], [14, 24], [37,, 39, 43], [49, 60]]);
      }))();
    },
    standardReportPromise: function standardReportPromise(url, header, obj) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__services_service_report__["a" /* default */].StandardReport(url, header, obj, function (result) {
          if (result.response === 'success') {
            resolve(result.data);
          } else {
            reject(new Error(result.message));
          }
        }, function (error) {
          reject(error);
        });
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(str).format('HH:mm:ss');
    },
    sum_qty: function sum_qty() {
      var sumQty = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            val['profit']['sub'].forEach(function (v) {
              sumQty += v['cn_qty'];
            });
          });
        }
      });
      return sumQty;
    },
    sumall_qty: function sumall_qty() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            if (val['group_code'] !== '9100') {
              // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_qty'];
              // }
            }
          });
        }
      });
      return sum;
    },
    sumall_avg_cost_sale: function sumall_avg_cost_sale() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            if (val['group_code'] !== '9100') {
              // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_avg_cost_sale'];
              // }
            }
          });
        }
      });
      return sum;
    },
    sumall_avg_cost_buy: function sumall_avg_cost_buy() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            if (val['group_code'] !== '9100') {
              // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_avg_cost_buy'];
              // }
            }
          });
        }
      });
      return sum;
    },
    sumall_tax_amount: function sumall_tax_amount() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            if (val['group_code'] !== '9100') {
              val['profit']['sub'].forEach(function (_val) {
                // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
                sum += _val['is_vat'] === 1 || _val['tax_amount'] > 0 ? _val['avg_cost_sale'] : 0;
                // }
              });
            }
          });
        }
      });
      return parseFloat(parseFloat(sum * 7 / 107).toFixed(2));
    },
    sumall_gross_profit_profile: function sumall_gross_profit_profile(sub) {
      var sum = 0;
      sub.forEach(function (o) {
        sum += o['avg_cost_buy'] / o['qty'];
      });
      return sum;
    },
    sumall_gross_profit: function sumall_gross_profit() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            if (val['group_code'] !== '9100') {
              // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_gross_profit'];
              // }
            }
          });
        }
      });
      return sum;
    },
    sumall_gpm: function sumall_gpm() {
      var sum = 0;
      var i = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            if (val['group_code'] !== '9100') {
              // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_gpm'];
              // }
            }
          });
          i++;
        }
      });
      return sum / i;
    },
    sumall_suminrow_taxamount: function sumall_suminrow_taxamount(sub) {
      var sum = 0;
      sub.forEach(function (o) {
        console.log(o);
        if (o['is_vat'] === 1) {
          // console.log(parseFloat(parseFloat(o['avg_cost_sale'] * 7 / 107).toFixed(2)))
          sum += parseFloat(parseFloat(o['avg_cost_sale'] * 7 / 107).toFixed(2));
        } else {
          sum += 0;
        }
      });
      return sum;
    },
    checkSub: function checkSub(obj) {
      var len = 0;
      if (obj !== null) {
        len += obj.profit.sub.length;
      }
      return len;
    },
    checkLastBranch: function checkLastBranch(obj) {
      var len = 0;
      obj.forEach(function (v) {
        if (v['profit']['sub'].length > 0) {
          len++;
        }
      });
      return len;
    },
    total_qty: function total_qty(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_qty'];
      });
      return sum;
    },
    total_gross_profit: function total_gross_profit(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_gross_profit'];
      });
      return sum;
    },
    total_avg_cost_sale: function total_avg_cost_sale(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_avg_cost_sale'];
      });
      return sum;
    },
    total_avg_cost_buy: function total_avg_cost_buy(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_avg_cost_buy'];
      });
      return sum;
    },
    getGroupItem: function getGroupItem() {
      var _this2 = this;

      var branch = 0;
      if (parseInt(this.branch) === 0) {
        branch = this.$store.state.branch_list[0];
      } else {
        branch = this.branch;
      }
      // apiItem.itemGroup(
      __WEBPACK_IMPORTED_MODULE_8__services_service__["a" /* default */].callMisApi(branch.dyn_address + '/' + 'product/v1/item/group', {
        headers: {
          'client-token': branch.access_token,
          'access-token': sessionStorage.token
        }
      }, {}, function (result) {
        console.log(result.response);
        if (result.response === 'success') {
          _this2.group_item = result.data;
          // this.group_data = [{
          //   name: 'ทุกกลุ่มสินค้า', code: ''
          // }]
          // result.data.forEach(val => {
          //   this.group_data.push({
          //     name: val['code'] + ': ' + val['name'],
          //     code: val['code']
          //   })
          // })
        } else {
          _this2.alert('warning', 'ดึงข้อมูลสินค้าไม่ได้', result.message);
        }
      }, function (error) {
        _this2.alert('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message);
      });
    }
    // getGroupItem () {
    //   var obj = {
    //     'id': 0,
    //     'company_id': 1,
    //     'branch_id': 1,
    //     'begin_date': this.dateFormatDMY2(this.startDate),
    //     'end_date': this.dateFormatDMY2(this.endDate)
    //   }
    //   this.$store.state.isLoading = true
    //   apiD.DashBoard(
    //     sessionStorage.Url,
    //     this.header,
    //     obj,
    //     result => {
    //       if (result.response === 'success') {
    //         this.$store.state.isLoading = false
    //         this.Sale_amount = 0
    //         this.Profit_amount = 0
    //         this.group_item = []
    //         result.data.forEach(v => {
    //           if (v !== null && v.length > 0) {
    //             v.forEach(val => {
    //               var check = this.group_item.findIndex(i => parseInt(i.group_code) === parseInt(val['group_code']))
    //               if (check < 0) {
    //                 this.group_item.push(val)
    //               }
    //             })
    //           }
    //         })
    //       } else {
    //         this.$store.state.isLoading = false
    //         this.alert_msg('warning', 'ดึงข้อมูลรายงานไม่ได้', result.message)
    //       }
    //     },
    //     error => {
    //       this.$store.state.isLoading = false
    //       this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
    //     }
    //   )
    // }

  },
  mounted: function mounted() {
    var _this3 = this;

    this.checkUser();
    this.getBranch();
    setTimeout(function () {
      _this3.getGroupItem();
    }, 1000);
    // this.getReport()
  }
});

/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-solid",style:({ 'min-height': _vm.$store.state.screenHeight - 200 + 'px' })},[_c('div',{staticClass:"card-header pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.branch=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getGroupItem]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกสาขา --")]),_vm._v(" "),_vm._l((_vm.$store.state.branch_list),function(b,i){return _c('option',{key:'branch' + i,domProps:{"value":b}},[_vm._v(_vm._s(b.branch_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("หมวดหมู่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.group),expression:"group"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.group=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกหมวดหมู่ --")]),_vm._v(" "),_vm._l((_vm.group_item),function(g,i){return _c('option',{key:'gi' + i,domProps:{"value":g}},[_vm._v(_vm._s(g.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_cost_sale.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.sum_qty() === 0}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_cost_sale.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.sum_qty() === 0}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},[_vm._l((_vm.report_data),function(c,i){return _c('table',{directives:[{name:"show",rawName:"v-show",value:(c.data !== null),expression:"c.data !== null"}],key:'c' + i,staticClass:"table"},_vm._l((c.data),function(d,s){return _c('tbody',{key:'d' + s},[(s === 0)?_c('tr',{staticClass:"text-left"},[_c('th',{staticStyle:{"font-size":"20px"},attrs:{"colspan":"6"}},[_vm._v("\n                สาขา: "+_vm._s(c.branch_name)+"\n              ")])]):_vm._e(),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticClass:"text-left"},[_c('th',{attrs:{"colspan":"6"}},[_vm._v("\n                หมวดหมู่: "+_vm._s(d.group_name)+"\n              ")])]):_vm._e(),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticClass:"text-left"},[_c('th',{attrs:{"colspan":"6"}},[_vm._v("\n                "+_vm._s(d.profit.date)+"\n              ")])]):_vm._e(),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticClass:"thead-dark text-center"},[_c('th',{attrs:{"width":"20%"}},[_vm._v("รหัส: ชื่อ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("มูลค่าขาย")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("มูลค่าทุนชื้อ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ต้นทุน/หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("กำไรขั้นต้น")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ภาษี 7 %")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("กำไร %")])]):_vm._e(),_vm._v(" "),_vm._l((d.profit.sub),function(sub,i){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(d.profit.sub.length > 0),expression:"d.profit.sub.length > 0"}],key:'sub' + i},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sub.item_code || '-')+": "+_vm._s(sub.item_name || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.avg_cost_sale)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.avg_cost_buy)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.avg_cost_buy / sub.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.gross_profit)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(sub.is_vat == 1 ? _vm.numberFormatDecimal(sub.avg_cost_sale * 7 / 107) : _vm.numberFormatDecimal(sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.gpm))+" %")])])}),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticStyle:{"background":"#f7f7f7"}},[_c('th',{staticClass:"text-left"},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_qty)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_avg_cost_sale)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_avg_cost_buy)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_gross_profit_profile(d.profit.sub))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_gross_profit)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_suminrow_taxamount(d.profit.sub))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_gpm))+" %")])]):_vm._e()],2)}),0)}),_vm._v(" "),_c('table',{staticClass:"table"},[(_vm.sum_qty() !== 0)?_c('tr',{staticStyle:{"background":"#f7f7f7","font-size":"20px"}},[_c('th',{staticClass:"text-left",attrs:{"width":"20%"}},[_vm._v("รวมทุกสาขา")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("มูลค่าขาย")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("มูลค่าทุนชื้อ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("กำไรขั้นต้น")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("\n              VAT 7 %\n            ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("\n              กำไร %\n            ")])]):_vm._e(),_vm._v(" "),(_vm.sum_qty() !== 0)?_c('tr',{staticStyle:{"background":"#f7f7f7","font-size":"20px"}},[_c('th',{staticClass:"text-left"}),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_qty())))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_avg_cost_sale())))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_avg_cost_buy())))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_gross_profit())))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_tax_amount())))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n              "+_vm._s(_vm.numberFormatDecimal((_vm.sumall_gross_profit() / _vm.sumall_avg_cost_sale()) * 100))+"\n            ")])]):_vm._e()])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/49.05ec1fd8d39a5d93e6bb.js